/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsGet } from "../funcs/agentsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import {
  GetAgentRequest,
  GetAgentSecurity,
} from "../models/operations/getagent.js";
import { unwrapAsync } from "../types/fp.js";
export type AgentQueryData = ManagedAgent;

export function prefetchAgent(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAgentRequest,
  security?: GetAgentSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAgentQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAgentQuery(
  client$: GramCore,
  request: GetAgentRequest,
  security?: GetAgentSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AgentQueryData>;
} {
  return {
    queryKey: queryKeyAgent({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function agentQueryFn(ctx): Promise<AgentQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAgent(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agents", "get", parameters];
}
